import { useCallback } from 'react';
import { type CoreRequest, useCore } from '$api-clients/hooks';

export type UserIntegration =
  CoreRequest<'/users/{id}/integrations'>['Data'][number];

export type IntegrationName = UserIntegration['name'];

type UserIntegrationsResult = {
  integrations: UserIntegration[] | undefined;
  loading: boolean;
  isIntegrationValid: (name: IntegrationName) => boolean;
};

export const useUserIntegrations = (
  userId?: string,
): UserIntegrationsResult => {
  const { data: integrations, isLoading: loading } = useCore(
    '/users/{id}/integrations',
    userId
      ? {
          params: {
            path: { id: userId },
          },
        }
      : null,
  );

  const isIntegrationValid = useCallback(
    (name: IntegrationName) => {
      const integration = integrations?.find((i) => i.name === name);
      return integration?.status === 'valid';
    },
    [integrations],
  );

  return { integrations, isIntegrationValid, loading };
};
